import { useState, useEffect } from "react";
import { Button } from "./ui/button";
import { X } from "lucide-react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookie-consent", "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#0f0f0f] border-t border-gray-800 p-4 shadow-lg" data-testid="cookie-banner">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex-1 text-sm text-gray-300">
          We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.
          <a href="/cookie-policy" className="text-[#d4af69] hover:underline ml-1">Learn more</a>
        </div>
        <div className="flex items-center gap-3">
          <Button
            onClick={declineCookies}
            variant="ghost"
            size="sm"
            className="text-gray-400 hover:text-gray-200"
            data-testid="decline-cookies"
          >
            Decline
          </Button>
          <Button
            onClick={acceptCookies}
            size="sm"
            className="bg-[#d4af69] hover:bg-[#c29d5a] text-white"
            data-testid="accept-cookies"
          >
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
}